import React from 'react';

const WarrantyInformationPage = React.lazy(() => import('pages/WarrantyInformation/WarrantyInformationPage'));

const WarrantyInformationRoutes = [
  {
    path: '/warranty-information',
    exact: true,
    name: 'Danh sách thiết bị bảo hành',
    function: 'WARRANTYINFORMATION_VIEW',
    component: WarrantyInformationPage,
  },
];

export default WarrantyInformationRoutes;
